import MuiRating from "@mui/material/Rating";
import { useState } from "react";
import { ratingStyles } from "./Rating.styles";
import styles from "./Rating.module.scss";

function Rating() {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState<number | null>(null);

  // Touch tracking
  const [startX, setStartX] = useState<number | null>(null);
  const [startY, setStartY] = useState<number | null>(null);
  const [isScrolling, setIsScrolling] = useState(false);

  const handleTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
    const { clientX, clientY } = event.touches[0];
    setStartX(clientX);
    setStartY(clientY);
    setIsScrolling(false);
  };

  const handleTouchMove = (event: React.TouchEvent<HTMLDivElement>) => {
    if (startX === null || startY === null) return;

    const touch = event.touches[0];
    const diffX = touch.clientX - startX;
    const diffY = touch.clientY - startY;

    // If user moves more vertically than horizontally, treat it as scroll
    if (Math.abs(diffY) > Math.abs(diffX)) {
      setIsScrolling(true);
      return;
    }

    // Otherwise, update hover rating based on horizontal movement
    const box = event.currentTarget.getBoundingClientRect();
    const touchPosition = touch.clientX - box.left;
    const newHoverRating = Math.min(
      5,
      Math.max(0, (touchPosition / box.width) * 5)
    );
    setHoverRating(Math.round(newHoverRating / 1));
  };

  const handleTouchEnd = () => {
    // If not scrolling, commit the hover rating
    if (!isScrolling && hoverRating !== null) {
      setRating(hoverRating);
    }
    // Reset
    setStartX(null);
    setStartY(null);
    setHoverRating(null);
    setIsScrolling(false);
  };

  return (
    <div
      className={styles.ratingWrapper}
      style={{ touchAction: "pan-y" }} // Allow vertical scrolling
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <MuiRating
        sx={ratingStyles}
        name="swipe-rating"
        value={hoverRating !== null ? hoverRating : rating}
        precision={1}
        onChange={(_event, newValue) => {
          if (newValue !== null) {
            setRating(newValue);
          }
        }}
      />
    </div>
  );
}

export default Rating;
